import { render, staticRenderFns } from "./App.vue?vue&type=template&id=20ed63eb"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "@/assets/scss/main.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/assets/scss/_reset.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "@/assets/scss/_fonts.scss?vue&type=style&index=2&prod&lang=scss&external"
import style3 from "@/assets/scss/_hover.scss?vue&type=style&index=3&prod&lang=scss&external"
import style4 from "@/assets/scss/_transition.scss?vue&type=style&index=4&prod&lang=scss&external"
import style5 from "@/assets/scss/_media.scss?vue&type=style&index=5&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports